import { render, staticRenderFns } from "./HomeSection.vue?vue&type=template&id=dcc3f9fa&scoped=true"
import script from "./HomeSection.vue?vue&type=script&lang=js"
export * from "./HomeSection.vue?vue&type=script&lang=js"
import style0 from "./HomeSection.vue?vue&type=style&index=0&id=dcc3f9fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcc3f9fa",
  null
  
)

export default component.exports